import { LoadingScreen } from "@/components/layout/Loading";
import NewQuoteCard from "@/components/pages/client/cards/new-quote-card";
import { QuoteCTASection } from "@/components/sections/section-quote-cta";
import QuoteCard from "@/components/ui/quote-card";
import { useAuth } from "@/contexts/auth-context";
import { getCotacoesEmAberto } from "@/services/clientAreaService";
import { OpenQuoteApiResponse } from "@/types/OpenQuote";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function OpenQuotePage() {
  const { user } = useAuth();
  const clientCode = user?.cli_codigo;
  const navigate = useNavigate();

  const [quotes, setQuotes] = useState<OpenQuoteApiResponse[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!clientCode) return;

    const fetchQuotes = async () => {
      try {
        const data = await getCotacoesEmAberto(clientCode);

        setQuotes(data);
      } catch (error) {
        console.error("Erro ao buscar cotações:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchQuotes();
  }, [clientCode]);

  const handleFinishQuote = (cveCodigo: string, token: string) => {
    navigate(`/cotacao/${cveCodigo}?token=${token}`);
  };

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <div className="py-6 sm:py-10 w-full max-w-7xl mx-auto">
      <h1 className="text-2xl sm:text-3xl font-bold text-n-green mb-10">
        Cotações em aberto
      </h1>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <div className="lg:col-span-8 flex flex-col gap-6">
          <div className="space-y-4 rounded-2xl bg-white px-5 py-4 sm:px-8 sm:py-6 shadow-sm">
            {!loading && quotes.length === 0 ? (
              <QuoteCTASection />
            ) : (
              quotes.map((q) => (
                <QuoteCard
                  key={q.ctc_codigo}
                  id={q.ctc_codigo}
                  from={q.mun_descricao_origem}
                  to={q.mun_descricao_destino}
                  vehicle={`${
                    q.vmd_descricao || "Veículo não informado"
                  } - ${q.cor_descricao || "Cor não informada"}`}
                  value={`R$ ${parseFloat(String(q.preco)).toFixed(2)}`}
                  expires=""
                  cveCodigo={q.cve_codigo}
                  onFinish={() =>
                    handleFinishQuote(q.cve_codigo, q.cve_token ?? "")
                  }
                />
              ))
            )}
          </div>
        </div>
        <div className="lg:col-span-4 flex flex-col gap-4">
          <NewQuoteCard
            onClick={() => window.open("/fazer-cotacao", "_blank")}
          />
        </div>
      </div>
    </div>
  );
}
